<template>
  <div>
    <button
      :id="'button-center_' + id"
      v-show="type_graph"
      class="home-button"
      @click="setDefaultPosition()"
    >
      <img src="@img/home.svg" alt="">
    </button>
    <div :id="id" :style="{height: graphComputedHeight}" :class="'graph-' + size"></div>
  </div>
</template>

<script>
import chartMapMix from '@mixins/chartMapMix'
import chartLineMix from '@mixins/chartLineMix'
import chartPieMix from '@mixins/chartPieMix'
import chartBarMix from '@mixins/chartBarMix'
import chartTableMix from '@mixins/chartTableMix'
import chartBarGroupMix from '@mixins/chartBarGroupMix'

// import httpStore from '@storages/httpStore'
import appStore from '@storages/appStore'
import reportStore from '@storages/reportStore'

export default {
  name: 'graph-component',
  props: ['id', 'type', 'graphData', 'size', 'lineChartOptions', 'dataSort', 'nameSort', 'barExtraOptions', 'mapExtraOptions'],
  mixins: [chartMapMix, chartLineMix, chartPieMix, chartBarMix, chartTableMix, chartBarGroupMix],
  watch: {
    dataSort (newVal, oldVal) {
      if (this.type !== 'bar' && this.type !== 'bar_chart') {
        return
      }
      let _columnName = this.graphData.y_axis.value_column
      if (newVal === 'ASC') {
        this.graphData.data.sort((a, b) => { return a[_columnName] > b[_columnName] ? -1 : 1 })
      } else {
        this.graphData.data.sort((a, b) => { return a[_columnName] > b[_columnName] ? 1 : -1 })
      }
      this.createChartBar(this.id, this.graphData, this.barExtraOptions)
    },
    nameSort (newVal, oldVal) {
      if (this.type !== 'bar' && this.type !== 'bar_chart') {
        return
      }
      let _columnName = this.graphData.x_axis.value_column
      if (newVal === 'ASC') {
        this.graphData.data.sort((a, b) => { return a[_columnName].toLowerCase() > b[_columnName].toLowerCase() ? -1 : 1 })
      } else {
        this.graphData.data.sort((a, b) => { return a[_columnName].toLowerCase() > b[_columnName].toLowerCase() ? 1 : -1 })
      }
      this.createChartBar(this.id, this.graphData, this.barExtraOptions)
    }
  },
  data () {
    return {
      type_graph: false,
      activePopupSourceLayerIndex: null,
      mapData: {}
    }
  },
  computed: {
    selectedOrder () {
      return reportStore.getters.value('selectedOrder')
    },
    graphComputedHeight () {
      switch (this.size) {
        case 'small':
          return '100%'

        case 'medium':
          return '450px'

        case 'big':
          return 'auto'

        case 'horizontal-bar':
          return this.getBarHeight()

        default:
          return 'auto'
      }
    }
  },
  created () {
    this.$on('go', this.go)
    this.$eventHub.$on('tableClick_' + this.id, this.tableClick) // не получилось прослушать emit с TableChart.vue, пришлось через eventHb
    this.$on('changeStyleButtonGoChild', this.changeStyleButtonGoChild)
    this.$on('getChildParams', this.getChildParams)
    this.$eventHub.$on('changeStyleButtonGoChildTable_' + this.id, this.changeStyleButtonGoChildTable)
    this.$eventHub.$on('change-preview-base-layer_' + this.id, this.changeBaseLayer)
  },
  beforeDestroy () {
    this.destroyPopup()
    this.$off('go')
    this.$eventHub.$off('tableClick_' + this.id)
    this.$eventHub.$off('changeStyleButtonGoChildTable_' + this.id)
    this.$off('getChildParams')
    this.$eventHub.$off('change-preview-base-layer_' + this.id)
  },
  mounted () {
    if (this.type === 'map') {
      this.mapData = this.createChartMap(this.id, this.graphData, this.mapExtraOptions)
      this.type_graph = true
    } else if (this.type === 'line_chart') {
      this.createChartLine(this.id, this.graphData, this.lineChartOptions)
    } else if (this.type === 'pie_chart') {
      this.createChartPie(this.id, this.graphData)
    } else if (this.type === 'bar' || this.type === 'bar_chart') {
      let _columnName = this.graphData.y_axis.value_column // сортировка по возрастанию по умолчанию
      this.graphData.data.sort((a, b) => { return a[_columnName] > b[_columnName] ? -1 : 1 })
      this.createChartBar(this.id, this.graphData, this.barExtraOptions)
    } else if (this.type === 'bar_chart_group') {
      this.createChartBarGroup(this.id, this.graphData)
    } else if (this.type === 'table' || this.type === 'table_chart') {
      this.createChartTable(this.id, this.graphData)
    }
  },
  methods: {
    setDefaultPosition () {
      if (this.mapData['typeMap'] === 'leaflets') {
        this.setDefaultPositionLeaflet(this.graphData, this.mapData['leafletMapData'])
      } else if (this.mapData['typeMap'] === 'echarts') {
        this.mapData['chart'].dispose()
        this.mapData = this.createChartMap(this.id, this.graphData, this.mapExtraOptions)
      }
    },
    changeBaseLayer (e) { // меняет базовый слой в превью
      if (e.blockId === this.id) { // если нужный блок
        let layersControl = this.map._controlCorners.topright // получаем контрол слоев
        let layers = layersControl.getElementsByTagName('span') // находим все варианты слоев
        let layer
        for (let i = 0; i < layers.length; i++) { // ищем наш слой
          if (layers[i].innerText.trim() === e.layerName) {
            layer = layers[i]
          }
        }
        if (layer !== undefined) { // если слой нашелся кликаем на надпись и он меняется
          layer.click()
          // console.log('change preview')
        }
      }
    },

    getBarHeight () {
      // return '1500px'
      return 60 + this.graphData.data.length * 30 + 'px'
    },

    getItemData (di, sourceLayerIndex) {
      try {
        switch (this.type) {
          case 'map':
            if (sourceLayerIndex !== undefined) {
              let item = this.graphData.layers[sourceLayerIndex].features.features[di]
              return item
            } else {
              let layerIndex = this.graphData.layers.findIndex(item => { return item.type === 'features' })
              if (layerIndex !== -1) {
                let item = this.graphData.layers[layerIndex].features.features[di]
                return item
              } else {
                return null
              }
            }

          case 'bar_chart_group':
            return this.graphData.data[di]

          case 'line_chart':
            return this.graphData.data[di]

          case 'bar': case 'bar_chart':
            return this.graphData.data[di]

          case 'pie': case 'pie_chart':
            return this.graphData.data[di]

          case 'table':
            return this.graphData.data[di]

          default:
            return null
        }
      } catch (error) {
        console.log('fail get data', error)
        return null
      }
    },

    getChildParams (e) {
      if (e.blockId !== this.id) {
        return
      }
      let _item = this.getItemData(e.dataIndex)
      if (this.type === 'map') {
        let _bbox = _item.bbox
        _item = _item.properties
        _item.bbox = _bbox
      }
      let _dictItemId = _item.dict_item_id
      let _name = _item.name
      this.$eventHub.$emit('getChild', {dictItemId: _dictItemId, name: _name, bbox: _item.bbox})
      this.destroyPopup()
    },

    changeStyleButtonGoChild (e) {
      if (e.blockId !== this.id) { // если событие было вызвано не этим графиком
        return
      }

      this.activePopupSourceLayerIndex = e.sourceLayerIndex

      if (document.body.clientWidth > 768) { // если пк(не телефон и не планшет)
        this.hideButtonGoChild()
        document.getElementById('popupWrapper').style.position = 'absolute'
        if (this.itemHasChild(e.dataIndex, e.sourceLayerIndex)) { // если есть куда провалиться
          this.$emit('getChildParams', {dataIndex: e.dataIndex, blockId: this.id}) // проваливаемся
          return
        }
      } else { // если телефон или планшет
        if (!this.itemHasChild(e.dataIndex, e.sourceLayerIndex)) { // Если некуда проваливаться прячем кнопку
          this.hideButtonGoChild()
        }
      }

      // позиционирование попапа
      if (document.body.clientWidth > 768) { // если ПК (не телефон и не плашет)
        // выравнивание блока на точку нажатия
        let _parent = null
        if (this.type === 'table') { // все графики, кроме table помещаются в окошко, у table же есть скролл и попап нужно вставлять в таблицу
          _parent = document.getElementById(this.id + '_table')
        } else {
          _parent = document.getElementById(this.id)
        }
        let _parentWidth = Number(window.getComputedStyle(_parent, null).getPropertyValue('width').replace('px', ''))

        let _popupWrapper = document.getElementById('popupWrapper')
        let _popupWidth = Number(window.getComputedStyle(_popupWrapper, null).getPropertyValue('width').replace('px', '')) // ширина попап окна
        let _popupHeight = Number(window.getComputedStyle(_popupWrapper, null).getPropertyValue('height').replace('px', '')) // высота
        let _popupLeft = Number(_popupWrapper.style.left.replace('px', '')) // лево
        let _popupTop = Number(_popupWrapper.style.top.replace('px', '')) // верх

        if ((_popupLeft - _popupWidth / 2) < 0) { // если попап вылезает слева
          _popupLeft = 0
        } else if ((_popupLeft + 230) > _parentWidth) { // если попап вылезает справа
          _popupLeft = _parentWidth - 230 // 220px - хардкодное значние ширины блока с надписью "Посмотреть на карте?". Оно не вычисляется т.к. в этот момент блок уже сгенерирован и его ширина некооректа(он сжимается)
        } else { // если попап помещается справа и слева
          _popupLeft = _popupLeft - (_popupWidth / 2) // сдвиг на пол ширины блока
        }

        if (_popupTop - _popupHeight < 0) {
          _popupTop = 0
        } else {
          _popupTop = _popupTop - _popupHeight - 3 // сдвиг на всю высоту без пары пикселей
        }

        _popupWrapper.style.left = _popupLeft + 'px' // присваивание новых значений
        _popupWrapper.style.top = _popupTop + 'px'
      } else { // если телефон или планшет
        let _popupWrapper = document.getElementById('popupWrapper')
        _popupWrapper.style.position = 'fixed'
        _popupWrapper.style.left = '0px' // присваивание новых значений
        _popupWrapper.style.top = 'unset'
        _popupWrapper.style.bottom = '0px'
      }
    },

    itemHasChild (di, sourceLayerIndex) {
      let item = this.getItemData(di, sourceLayerIndex)
      if (this.type === 'map') {
        item = item.properties
      }
      let _selectedReport = reportStore.getters.value('selectedReport')
      if (item === null) {
        return false
      }
      if ('indivisible' in item && (item.indivisible === true || item.indivisible === 'true' || item.indivisible === 1 || item.indivisible === '1')) {
        return false
      }
      if (item.dict_item_id !== null && item.dict_item_id !== 'null' && item.dict_item_id !== undefined) {
        if (_selectedReport.dict !== null && _selectedReport.dict !== 'null' && 'child' in _selectedReport.dict && _selectedReport.dict.child !== null && _selectedReport.dict.child !== 'null') {
          return true
        }
      }
      return false
    },

    hideButtonGoChild () {
      let _buttonGoChild = document.getElementById('popupButtonGoChild')
      // _buttonGoChild.onclick = e => { console.log('no childrens') }
      _buttonGoChild.style.display = 'none'
    },

    tableClick (e) {
      if (this.id === e.blockId) { // проверка на то что нажатие обрабатывается только в нужном компоненте, а не во всех graph.vue которые услышали тоже событие
        this.go(e)
      }
    },
    changeStyleButtonGoChildTable (e) {
      if (this.id === e.blockId) { // проверка на то что нажатие обрабатывается только в нужном компоненте, а не во всех graph.vue которые услышали тоже событие
        this.changeStyleButtonGoChild(e)
      }
    },

    go (e) {
      // if (e.blockId.indexOf('reportFullscreen') === -1) {
      //   return
      // }
      let _appConfig = appStore.getters.value('config')
      let _serviceConfig = _appConfig.services.find(item => { return item.service_id === _appConfig.service_id })
      let _url = _serviceConfig.url + 'orders/' + this.selectedOrder.order_id + '/'
      let _bbox = this.getBbox(e.dataIndex)
      /* eslint-disable-next-line */
      if (!!_bbox) {
        _url += 'bbox/' + String(_bbox)
      } else {
        _url += 'bbox/' + String(this.getBboxFromOrder(this.selectedOrder.bbox.coordinates[0])) + '/'
      }
      let _slice = this.getSlice(e.dataIndex)
      /* eslint-disable-next-line */
      if (!!_slice) {
        _url += '/slice/' + _slice + '/'
      }
      // console.log(_url)
      window.open(_url, '_blank')
      // window.location.href = _url
    },

    // bbox funcitons
    getBboxFromOrder (polygon) {
      return this.getBboxFromPolygonMix(polygon)
    },

    getBbox (dataIndex) {
      let item = this.getItemData(dataIndex, this.activePopupSourceLayerIndex)
      /* eslint-disable-next-line */
      if (!!item) {
        return item.bbox
      } else {
        return null
      }
    },

    // slice fuctions
    getSlice (di) {
      let item = this.getItemData(di, this.activePopupSourceLayerIndex)
      if (this.type === 'map') {
        item = item.properties
      }
      /* eslint-disable-next-line */
      if (!!item && 'slice_date' in item) {
        return item.slice_date.substring(0, item.slice_date.indexOf(' '))
      } else {
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/varibles.scss';

.home-button {
  position: absolute;
  border: none;
  top: 10px;
  left: 10px;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  box-shadow: 0 1px 5px rgba(0,0,0,0.4);
  background-color: #fff;
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home-button svg {
  margin-top: 3px;
}
.home-button img {
  width: 24px;
  // height: 100%;
}

.graph-title {
  width: 100%;
  height: 35px;
}
.graph-title__text {
  font-weight: bold;
}
.graph-small {
  width: 100%;
  /* min-height: 315px; */
  height: 350px;
  height: 100%;
  overflow: hidden;
}
.graph-medium {
  width: 100%;
  /* height: 415px; */
  height: 450px;
}
.graph-big {
  width: 100%;
  /* height: 615px; */
  // height: calc(#{$Height-report-full-graph} - 40px)
  height: $Height-report-full-graph!important;
}
.graph-horizontal-bar {
  width: 100%;
  height: 1500px;
  // height: $Height-report-full-graph;
}
.graph-table {
  width: 100%;
  height: max-content;
  overflow-y: auto;
}
@media (max-width: 800px) {
  .graph-small {
    height: $Height-report-small-graph__mobile;
  }
  .graph-big {
    // height: $Height-report-small-graph__mobile;
    height: calc(100vh - 60px);
  }
  .graph-horizontal-bar {
    // height: $Height-report-small-graph__mobile;
    height: 1500px;
  }
  .graph-table {
    // height: $Height-report-small-graph__mobile;
    height: calc(100vh - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Graph.vue